import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { downloadProjectDocument } from "../../../../../service/project";
import { getProjectDocuments, GetProjectDocumentsResponse } from "../../../../../service/publicquery";
import { Status } from "../../../../../service/Shared";
import { initiateDocumentDownloadViaBrowser } from "../../../../../utils";
import { ProjectContext } from "../../../../shared/projects/project/ProjectContext";

type ProjectPageRouteParams = "projectUuid";

interface UseDocumentsReturnData {
  documents: GetProjectDocumentsResponse[] | undefined;
  isLoading: boolean;
  isFullAccessProject: boolean;
  downloadDocument: (projectDocumentHistoryUuid: string) => Promise<void>;
}

export const useDocuments = (): UseDocumentsReturnData => {
  const { projectDetails, publicProjectDetails } = useContext(ProjectContext);
  const { projectUuid } = useParams<ProjectPageRouteParams>();
  const [documents, setDocuments] = useState<GetProjectDocumentsResponse[]>();
  const [isLoading, setIsLoading] = useState(true);

  const downloadDocument = async (projectDocumentHistoryUuid: string): Promise<void> => {
    const res = await downloadProjectDocument({ projectDocumentHistoryUuid });

    initiateDocumentDownloadViaBrowser(res);
  };

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      if (projectDetails) {
        setIsLoading(false);
        return;
      }

      if (!projectUuid || !publicProjectDetails) {
        setIsLoading(false);
        return;
      }

      await getProjectDocuments({
        projectUuid,
        groupUuid: publicProjectDetails.group?.groupUuid || null,
      })
        .then((response) => {
          if (response.status === Status.Success) {
            setDocuments(response.data);
          }
        })
        .finally(() => setIsLoading(false));
    };

    fetchData().catch(() => setIsLoading(false));
  }, [projectDetails, projectUuid, publicProjectDetails]);

  return {
    documents,
    isLoading,
    isFullAccessProject: !!projectDetails,
    downloadDocument,
  };
};
